export default {
  inventoryAdjustment: require("./inventory-adjustment").default,
  inventoryCancel: require("./inventory-cancel").default,
  inventoryEndOfMonthCheck: require("./inventory-end-of-month-check").default,
  inventorySlipInstant: require("./inventory-slip-instant").default,
  inventorySlip: require("./inventory-slip").default,
  inventoryReturn: require("./inventory-return").default,
};
